var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9471 7.66048C19.8843 7.47537 19.7686 7.31272 19.6143 7.19261C19.4601 7.07249 19.274 7.00017 19.0791 6.98457L13.3781 6.53163L10.9111 1.07136C10.8325 0.895494 10.7047 0.746123 10.5431 0.641273C10.3815 0.536423 10.193 0.480575 10.0004 0.480469C9.80777 0.480363 9.61922 0.536004 9.45751 0.640677C9.2958 0.74535 9.16784 0.89458 9.08908 1.07036L6.62206 6.53163L0.921032 6.98457C0.729486 6.99975 0.546368 7.06977 0.393584 7.18628C0.2408 7.30278 0.12482 7.46083 0.0595198 7.64152C-0.00578041 7.8222 -0.017636 8.01787 0.0253714 8.20512C0.0683787 8.39236 0.164428 8.56325 0.302028 8.69735L4.51505 12.8038L3.02504 19.2549C2.9798 19.4502 2.9943 19.6546 3.06666 19.8415C3.13903 20.0284 3.26591 20.1893 3.43085 20.3032C3.59579 20.4172 3.79117 20.4789 3.99163 20.4804C4.1921 20.482 4.3884 20.4232 4.55505 20.3118L10.0001 16.6823L15.4451 20.3118C15.6155 20.4249 15.8163 20.4831 16.0208 20.4786C16.2252 20.4741 16.4233 20.4072 16.5885 20.2867C16.7537 20.1663 16.8781 19.9982 16.9449 19.8049C17.0117 19.6117 17.0177 19.4027 16.9621 19.206L15.1331 12.8068L19.6691 8.72534C19.9661 8.45738 20.0751 8.03943 19.9471 7.66048Z",
    fill: "#F4871F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.159d4e72c43b1b613edbf927606a24b3.svg";
export { ForwardRef as ReactComponent };